import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./Card.module.scss";

const Card = ({
    children,
    className,
    ...restProps
}: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>) => {
    return (
        <div className={classNames(className, styles.root)} {...restProps}>
            {children}
        </div>
    );
};
Card.defaultProps = {
    className: undefined,
    style: undefined,
};

export default Card;
